import { render, staticRenderFns } from "./home-menu-item.vue?vue&type=template&id=75901b4e"
import script from "./home-menu-item.vue?vue&type=script&lang=js"
export * from "./home-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports